import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import "./styles.css";
import { goBack } from "../../../../utils/gotoback";
import { loadingShow } from "../../../../services/PostAPI";
import Breadcrumb from "../../../../common/Breadcrumb";
import { Calendar } from "primereact/calendar";
import { Controller } from "react-hook-form";
import { useStyles } from "../style";
import {
  basicDetail,
  driverageDD,
  editMode,
  statusDD,
  typeDD,
} from "../CreateReservationsReservations/constant";
import { Box, Container, Grid, Typography } from "@mui/material";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { useNavigate } from "react-router-dom";
import { APP_URLS } from "../../../../utils/constant";
import EzControlledCalendarWithFloatingLabel from "../../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../../../utils/form/form-utils";
import EzControlledCheckBoxWithLabel from "../../../../common/EzForm/EzControlledCheckBox/WithLabel";
import { ReservationsReservationsBreadcrumb } from "../../ReservationsReservations/CreateReservationsReservations/constant";
import { hourslist } from "../../../Location/CreateLocation/constant";
import EzControlledInputAreaWithFloatingLabel from "../../../../common/EzForm/EzControlledInputArea/WithFloatingLabel";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import HeatPumpIcon from "@mui/icons-material/HeatPump";
import SpeedIcon from "@mui/icons-material/Speed";
import CardICON from "../../../../images/car-door.png";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  formatDates,
  formatDatesHyphan,
  formatDatesMmDdYyyy,
  getCurrentAndThreeDaysLater,
} from "../../../../utils";

// Helper function to convert time string like "10:00AM" to minutes since midnight
const parseTimeToMinutes = (timeStr) => {
  if (!timeStr) return 0;
  const match = timeStr.match(/(\d{1,2}):(\d{2})(AM|PM)/i);
  if (!match) return 0;
  let hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const period = match[3].toUpperCase();
  
  if (period === "AM" && hours === 12) hours = 0;
  else if (period === "PM" && hours !== 12) hours += 12;
  
  return hours * 60 + minutes;
};

// Check if a date is today
const isToday = (date) => {
  if (!date) return false;
  const today = new Date();
  const compareDate = new Date(date);
  return (
    compareDate.getDate() === today.getDate() &&
    compareDate.getMonth() === today.getMonth() &&
    compareDate.getFullYear() === today.getFullYear()
  );
};

// Filter time options based on selected date
const getFilteredTimeOptions = (selectedDate, timeList) => {
  if (!isToday(selectedDate)) {
    return timeList;
  }
  
  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  
  return timeList.filter((time) => {
    const timeMinutes = parseTimeToMinutes(time.id);
    return timeMinutes > currentMinutes;
  });
};

const getDefaultFutureTime = (timeList) => {
  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  
  const futureTime = timeList.find((time) => {
    const timeMinutes = parseTimeToMinutes(time.id);
    return timeMinutes > currentMinutes;
  });
  
  return futureTime?.id || timeList[0]?.id || "10:00AM";
};

const CreateReservationsReservationsComponent = (props) => {
  const navigate = useNavigate();
  const {
    history,
    initCreateReservationsReservationsScreen,
    createReservationsReservations,
    searchReservationsReservations,
    editReservationsReservations,
    isLoading,
    isReservationsReservationsCreateSuccess,
    isReservationsReservationsCreateError,
    isReservationsReservationsDetailSuccess,
    isReservationsReservationsDetailError,
    isReservationsReservationsEditSuccess,
    isReservationsReservationsSearchSuccess,
    isReservationsReservationsSearchError,
    isEdit,
    isView,
    formFieldValueMap,
    shouldBlockNavigation,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
    vehicleModelDD,
    isVehicleModelDDSuccess,
    isVehicleModelDDError,
    locationDD,
    vehicleCategoryDD,
  } = props;

  const classes = useStyles();
  const { currentDate, threeDaysLater } = getCurrentAndThreeDaysLater();
  const {
    control,
    formState: { errors, isDirty },
    watch,
    register,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });
  let searchfiled = {
    pickUpDate: currentDate,
    dropOffDate: threeDaysLater,
    locationId: 0,
    categoryId: 0,
    pickUpTime: getDefaultFutureTime(hourslist),
    dropOffTime: getDefaultFutureTime(hourslist),
    driverAge: 2,
  };
  const {
    handleSubmit: handleSubmit2,
    control: control2,
    register: register2,
    reset: resetForm2,
    setValue: setValue2,
    formState: { errors: errors2, isDirty: isDirty2 },
    watch: watch2,
  } = useForm({
    defaultValues: useMemo(() => {
      return searchfiled;
    }, [searchfiled]),
  });

  const [amountTotal, setAmountTotal] = useState(0);

  const [extraamountTotal, setExtraAmountTotal] = useState(0);
  const [damageTotal, setDamageTotal] = useState(0);
  const [additionalDriverTotal, setAdditionalDriverTotal] = useState(0);
  const [glassTiresTotal, setGlassTiresTotal] = useState(0);
  const [equipmentTotal, setEquipmentTotal] = useState(0);
  const [outofProvinceTotal, setOutofProvinceTotal] = useState(0);
  const [extraMileageTotal, setExtraMileageTotal] = useState(0);

  const [other, setOther] = useState({}); //otherData
  const [estimatedTax, setEstimatedTax] = useState(); // EstimatedTax
  const [paymentOption, setPaymentOption] = useState([]); //payOptionData
  const [damage, setDamage] = useState([]); //damageData
  const [additionalDriver, setAdditionalDriver] = useState([]);
  const [glassTires, setGlassTires] = useState([]); //glassTiresData
  const [equipment, setEquipment] = useState([]); //equipmentData
  const [outofProvince, setOutofProvince] = useState([]); //outofProvinceData
  const [extraMileage, setExtraMileage] = useState([]); //extraMileageData
  const [extraBoll, setExtraBoll] = useState(false);
  const [searchPayload, setSearchPayload] = useState({});
  const [discount, setDiscount] = useState(0); //Pay now discount

  // Watch date fields to filter time options
  const watchPickUpDate = watch2("pickUpDate");
  const watchDropOffDate = watch2("dropOffDate");

  // Auto-set dropOffDate to pickUpDate + 2 days
  useEffect(() => {
    if (watchPickUpDate) {
      const pickUp = new Date(watchPickUpDate);
      if (!isNaN(pickUp.getTime())) {
        const dropOff = new Date(pickUp);
        dropOff.setDate(dropOff.getDate() + 2);
        setValue2("dropOffDate", dropOff);
      }
    }
  }, [watchPickUpDate]);

  // Filtered time options based on selected dates
  const pickupTimeOptions = useMemo(() => {
    return getFilteredTimeOptions(watchPickUpDate, hourslist);
  }, [watchPickUpDate]);

  const dropoffTimeOptions = useMemo(() => {
    return getFilteredTimeOptions(watchDropOffDate, hourslist);
  }, [watchDropOffDate]);
  
  const navigateToReservationsReservationsScreen = () => {
    navigate(APP_URLS.RESERVATIONS_RESERVATIONS.HOME, { state: { fromDetail: true } });
  };

  const [inclusiveRate, setInclusiveRate] = useState(false);
  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setInclusiveRate(checked);
  };

  const onSubmit2 = (data) => {
    let newData = data;
    newData["pickUpDate"] = formatDatesHyphan(data?.pickUpDate);
    newData["dropOffDate"] = formatDatesHyphan(data?.dropOffDate);

    const stringifiedData = {
      ...newData,
    };
    setSearchPayload(stringifiedData);
    searchReservationsReservations(stringifiedData);
    reset(formFieldValueMap);
  };
  useEffect(() => {
    if (
      isReservationsReservationsCreateSuccess ||
      isReservationsReservationsEditSuccess
    ) {
      reset();
    }
  }, [isReservationsReservationsCreateSuccess]);
  useEffect(() => {
    if (isReservationsReservationsSearchSuccess) {
      reset({
        ...formFieldValueMap,
      });
      handleVisualCalc(formFieldValueMap);
    }
  }, [isReservationsReservationsSearchSuccess]);
  useEffect(() => {
    initCreateReservationsReservationsScreen();
  }, []);

  const calculateEstimatedTax = (dataset, extrasTotal = 0) => {
    const {
      afterFee,
      payNowdiscountBeforeTax = 0,
      fee = 0,
      concessionFee = 0,
      airportFacilityChargeTotal = 0,
      afterHourFee = 0,
      afterHourDropoffFee = 0,
      taxPercent = 0,
    } = dataset;

    const taxBase = Number(payNowdiscountBeforeTax);
    const taxRate = Number(taxPercent) / 100;

    if (afterFee === 1) {
      return (
        (taxBase +
          fee +
          extrasTotal +
          concessionFee +
          airportFacilityChargeTotal +
          afterHourFee +
          afterHourDropoffFee) *
        taxRate
      );
    } else {
      return (taxBase + extrasTotal + fee + concessionFee + airportFacilityChargeTotal + afterHourDropoffFee) * taxRate;
    }
  };

  const getGrandTotal = (mode, data, estTax) => {
    const fee = Number(data.fee) || 0;
    const concessionFee = Number(data.concessionFee) || 0;
    const airportFacilityCharge = Number(data.airportFacilityChargeTotal) || 0;
    const afterHourFee = Number(data.afterHourFee) || 0;
    const afterHourDropoffFee = Number(data.afterHourDropoffFee) || 0;

    if (mode === "Pay Now") {
      const payNowBase = Number(data.payNowdiscountBeforeTax) || 0;
      return payNowBase + fee + concessionFee + airportFacilityCharge + afterHourFee + afterHourDropoffFee + estTax;
    }
    const payLaterBase = Number(data.totalRateSelected ?? data.payLater) || 0;
    return payLaterBase + fee + concessionFee + airportFacilityCharge + afterHourFee + afterHourDropoffFee + estTax;
  };

  const handleVisualCalc = (dataset) => {
    let payOptionsDatas = [
      {
        id: 1,
        name: "Pay Now",
        value: dataset?.payNowdiscountBeforeTax,
        discount: dataset?.payNowDiscountAmont,
      },
      { id: 2, name: "Pay Later", value: dataset?.payLater, discount: 0 },
    ];

    let payOptionData = payOptionsDatas;
    payOptionData = payOptionData.map((item, idx) => ({
      ...item,
      isChecked: idx === 0 ? true : false,
    }));

    const selected = payOptionData.find((item) => item.isChecked);
    setDiscount(selected?.discount || 0);

    // Damage Data
    let damageData = dataset?.damageProtection ?? [];
    damageData = damageData.map((item, idx) => ({
      ...item,
      isChecked: idx === 0 ? true : false,
    }));

    // Additional Driver
    let additionalDriverData = dataset.additionalDriver ?? [];
    additionalDriverData = additionalDriverData.map((item, idx) => ({
      ...item,
      isChecked: idx === 0 ? true : false,
    }));

    // GlassTires
    let glassTiresData = dataset.glassTires ?? [];
    glassTiresData = glassTiresData.map((item, idx) => ({
      ...item,
      isChecked: idx === 0 ? true : false,
    }));
    // GlassTires
    let equipmentData = dataset.equipment ?? [];
    equipmentData = equipmentData.map((item, idx) => ({
      ...item,
      isChecked: false,
    }));
    // OutofProvince
    let outofProvinceData = dataset.outOfProvince ?? [];
    outofProvinceData = outofProvinceData.map((item, idx) => ({
      ...item,
      isChecked: idx === 0 ? true : false,
    }));
    // ExtraMileage
    let extraMileageData = dataset.extraMileage ?? [];
    extraMileageData = extraMileageData.map((item, idx) => ({
      ...item,
      isChecked: idx === 0 ? true : false,
    }));
    setPaymentOption(payOptionData);
    setOther(dataset);
    setAdditionalDriver(additionalDriverData);
    setAmountTotal(dataset?.totalAmount);
    setDamage(damageData);
    setGlassTires(glassTiresData);
    setEquipment(equipmentData);
    setOutofProvince(outofProvinceData);
    setExtraMileage(extraMileageData);
  };
  const onSubmit = (data) => {
    let newData = data;
    newData["userId"] = localStorage.getItem("userId");
    const po =
      paymentOption.filter((item) => item.isChecked === true)[0] || null;
    const oop =
      outofProvince.filter((item) => item.isChecked === true)[0] || null;
    const add =
      additionalDriver.filter((item) => item.isChecked === true)[0] || null;
    const dpp = damage.filter((item) => item.isChecked === true)[0] || null;
    const em =
      extraMileage.filter((item) => item.isChecked === true)[0] || null;
    const gt = glassTires.filter((item) => item.isChecked === true)[0] || null;
    const rel = equipment.filter((item) => item.isChecked === true) || null;
    let eqpdata = rel.map((item) => ({
      eqId: item?.id,
      eqVal: item?.amount,
    }));
    const stringifiedData = {
      addId: add?.id,
      addVal: add?.amount,
      address: newData?.address,
      airportConcessionFee: newData?.concessionFee,
      airportFacilityChargeTotal: newData?.airportFacilityChargeTotal,
      beforeTax: po?.value,
      cardExpiry: newData?.cardExpiry,
      categoryId: searchPayload?.categoryId,
      creditCardNumber: newData?.creditCardNumber,
      cvv: newData?.cvv,
      days: newData?.airportFacilityChargeTotalForDays,
      dppId: dpp?.id,
      dppVal: dpp?.amount,
      driverAge: searchPayload?.driverAge,
      dropOffDate: formatDatesMmDdYyyy(searchPayload?.dropOffDate),
      dropOffTime: searchPayload?.dropOffTime,
      emId: em?.id,
      emVal: em?.amount,
      emailId: newData?.emailId,
      fees: newData?.fee,
      firstName: newData?.firstName,
      flightDetails: newData?.flightDetails,
      gtId: gt?.id,
      gtVal: gt?.amount,
      lastName: newData?.lastName,
      locationAfterHourFee: newData?.afterHourFee,
      locationAfterHourDropoffFee: newData?.afterHourDropoffFee,
      locationId: searchPayload?.locationId,
      nameOnCard: newData?.nameOnCard,
      netDailyRate: "",
      oopId: oop?.id,
      oopVal: oop?.amount,
      payNow: po?.id,
      phoneNumber: newData?.phoneNumber,
      pickUpDate: formatDatesMmDdYyyy(searchPayload?.pickUpDate),
      pickUpTime: searchPayload?.pickUpTime,
      remainderHours: "",
      reservationEquipmentList: eqpdata ?? [],
      reservationSearchRequest: JSON.stringify(searchPayload),
      taxAmountDiscount: estimatedTax,
      totalAmount: amountTotal,
      type: "",
    };

    isEdit
      ? editReservationsReservations({ id: data.id, data: stringifiedData })
      : createReservationsReservations(stringifiedData);
  };

  const getToastProps = () => {
    const toastTitle = "Please select category from list";
    return {
      severity: TOAST_SEVERITY.ERROR,
      toastTitle,
      shouldShowToast: false,
    };
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };
  const getTotalCheckedValue = (items) => {
    return items
      .filter((item) => item.isChecked)
      .reduce((sum, item) => sum + item.amount, 0);
  };
  const handleTotalAmount = () => {
    const po =
      paymentOption.filter((item) => item.isChecked === true)[0] || null;
    // old tatal amount calc
    // let totalValue = other.totalAmount;
    // totalValue = totalValue - po?.discount ?? 0;

    const damValue =
      damage.find((item) => item.isChecked === true)?.amount || 0;
    const ofpValue =
      outofProvince.find((item) => item.isChecked === true)?.amount || 0;
    const adValue =
      additionalDriver.find((item) => item.isChecked === true)?.amount || 0;
    const gtValue =
      glassTires.find((item) => item.isChecked === true)?.amount || 0;
    const emValue =
      extraMileage.find((item) => item.isChecked === true)?.amount || 0;
    const eqpValue = getTotalCheckedValue(equipment);

    const extrasTotal =
      damValue + ofpValue + adValue + gtValue + emValue + eqpValue;

    //new total amount calc
    const taxDataset = {
      ...other,
      payNowdiscountBeforeTax: po?.value,
    };
    const newEstTax = calculateEstimatedTax(taxDataset, extrasTotal);
    setEstimatedTax(newEstTax);
    let baseTotal = getGrandTotal(po?.name, other, newEstTax);


    setExtraAmountTotal(extrasTotal ?? 0);
    setDamageTotal(damValue ?? 0);
    setAdditionalDriverTotal(adValue ?? 0);
    setGlassTiresTotal(gtValue ?? 0);
    setEquipmentTotal(eqpValue ?? 0);
    setOutofProvinceTotal(ofpValue ?? 0);
    setExtraMileageTotal(emValue ?? 0);
    // const finalTotal =
    //   totalValue + damValue + ofpValue + adValue + gtValue + emValue + eqpValue;
    setAmountTotal(baseTotal + extrasTotal);
  };

  useEffect(() => {
    handleTotalAmount();
  }, [
    other,
    damage,
    outofProvince,
    additionalDriver,
    glassTires,
    extraMileage,
    equipment,
    paymentOption,
  ]);

  const handleExtra = () => {
    setExtraBoll(!extraBoll);
  };

  const handleRadio = (e, i) => {
    let { name, value, checked } = e.target;
    if (name === "payOption") {
      const updatedData = paymentOption.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );

      setPaymentOption(updatedData);
      const selected = updatedData[i];
      setDiscount(selected?.discount || 0);
      const po =
        paymentOption.filter((item) => item.isChecked === true)[0] || null;
      let totalValue = other.totalAmount;

      totalValue = totalValue - po.discount;

      setAmountTotal(totalValue);
    }
    if (name === "damage") {
      const updatedData = damage.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );
      setDamage(updatedData);
    }
    if (name === "outofProvince") {
      const updatedData = outofProvince.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );
      setOutofProvince(updatedData);
    }

    if (name === "additionalDriver") {
      const updatedData = additionalDriver.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );
      setAdditionalDriver(updatedData);
    }

    if (name === "glassTires") {
      const updatedData = glassTires.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );
      setGlassTires(updatedData);
    }

    if (name === "equipment") {
      const updatedData = equipment.map((item, index) =>
        i === index ? { ...item, isChecked: checked } : { ...item }
      );
      setEquipment(updatedData);
    }

    if (name === "extraMileage") {
      const updatedData = extraMileage.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );
      setExtraMileage(updatedData);
    }
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Create Reservations</h4>
          </div>
          <div className="buttonarea">
            <Button
              tooltip={"Back to Reservations"}
              tooltipOptions={{ position: "left" }}
              label={"Back to Reservations"}
              // icon={"pi pi-arrow-left"}
              className={`p-button `}
              style={{ borderRadius: "10px" }}
              onClick={navigateToReservationsReservationsScreen}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container maxWidth="lg">
      <Breadcrumb list={ReservationsReservationsBreadcrumb} />
      <EzToast {...getToastProps()} />
      <div className={`containerbox ${classes.bg}`} >
        {renderPageHeaderSection()}
        <div className="form-demo mrt30" >
          <form onSubmit={handleSubmit2(onSubmit2)} className="p-fluid" >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledDropDowntWithFloatingLabel
                  name="locationId"
                  control={control2}
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  optionLabel={"name"}
                  optionValue={"id"}
                  options={locationDD}
                  isError={errors2["locationId"]}
                  errorMsg={getFormErrorMessage("locationId")}
                  label="Location"
                  labelClassName={"ml-2"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledDropDowntWithFloatingLabel
                  name="categoryId"
                  control={control2}
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  optionLabel={"name"}
                  optionValue={"id"}
                  options={vehicleCategoryDD}
                  isError={errors2["categoryId"]}
                  errorMsg={getFormErrorMessage("categoryId")}
                  label="Vehicle"
                  labelClassName={"ml-2"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledCalendarWithFloatingLabel
                  id="pickUpDate"
                  name="pickUpDate"
                  {...register2("pickUpDate")}
                  showTime={false}
                  minDate={new Date()}
                  maxDate={new Date(2090, 0, 1)}
                  dateFormat="yy/mm/dd"
                  control={control2}
                  isError={errors2["pickUpDate"]}
                  errorMsg={getFormErrorMessage("pickUpDate")}
                  label="Pickup Date"
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledDropDowntWithFloatingLabel
                  name="pickUpTime"
                  control={control2}
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  optionLabel={"name"}
                  optionValue={"id"}
                  options={pickupTimeOptions}
                  isError={errors2["pickUpTime"]}
                  errorMsg={getFormErrorMessage("pickUpTime")}
                  label="Pickup Time"
                  labelClassName={"ml-2"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledCalendarWithFloatingLabel
                  id="dropOffDate"
                  name="dropOffDate"
                  {...register2("dropOffDate")}
                  showTime={false}
                  minDate={new Date()}
                  maxDate={new Date(2090, 0, 1)}
                  dateFormat="yy/mm/dd"
                  control={control2}
                  isError={errors2["dropOffDate"]}
                  errorMsg={getFormErrorMessage("dropOffDate")}
                  label="Dropoff Date"
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledDropDowntWithFloatingLabel
                  name="dropOffTime"
                  control={control2}
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  optionLabel={"name"}
                  optionValue={"id"}
                  options={dropoffTimeOptions}
                  isError={errors2["dropOffTime"]}
                  errorMsg={getFormErrorMessage("dropOffTime")}
                  label="Dropoff Time"
                  labelClassName={"ml-2"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledDropDowntWithFloatingLabel
                  name="driverAge"
                  control={control2}
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  optionLabel={"name"}
                  optionValue={"id"}
                  options={driverageDD}
                  isError={errors2["driverAge"]}
                  errorMsg={getFormErrorMessage("driverAge")}
                  label="Driver's Age"
                  labelClassName={"ml-2"}
                />
              </Grid>
              <Grid item mb={2}>
                <div style={{ margin: "0px 0px 0px 10px", maxWidth: "100px" }}>
                  <Button
                    type="button"
                    label={"Search"}
                    className="p-button-raised"
                    onClick={handleSubmit2(onSubmit2)}
                  />
                </div>
              </Grid>
            </Grid>
          </form>
          {/* {JSON.stringify(formFieldValueMap)} */}
          {other !== undefined && Object.keys(other).length > 0 && (
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
              <Grid container spacing={2}>
                <Grid item sx={12} lg={8}>
                  <Typography className="headbgblue" variant="h6">
                    Selected Vehicle Information
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={5} sm={5}>
                      <Box>
                        <img className="imgbox_renter" src={other?.imageURL} />
                      </Box>
                      <p className="vantype">{other?.categoryTitle}</p>
                      <Box className="vandetails">
                        <ul>
                          <li>
                            <Diversity3Icon />
                            <span>{other?.passenger}</span>
                          </li>
                          <li>
                            <BusinessCenterIcon />
                            <span>{other?.luggage}</span>
                          </li>
                          <li>
                            <ManageAccountsIcon />
                            <span>{other?.transmission}</span>
                          </li>
                          <li>
                            <img src={CardICON} />
                            <span>{other?.doors}</span>
                          </li>
                          <li>
                            <HeatPumpIcon />
                            <span>{other?.ac}</span>
                          </li>
                          <li>
                            <SpeedIcon />
                            <span>LTD</span>
                          </li>
                        </ul>
                      </Box>
                    </Grid>
                    <Grid item sx={12} sm={7} className="boxmidright" >
                      <Grid container spacing={2} sx={12} style={{width:"100%"}}>
                        {paymentOption.map((item, index) => (
                          <Grid
                            position={"relative"}
                            key={"idx" + index}
                            item
                            xs={12}
                            alignItems={"left"}
                            textAlign={"left"}
                          >
                            <input
                              checked={item.isChecked}
                              type="radio"
                              onChange={(e) => handleRadio(e, index)}
                              name="payOption"
                              value={item.value}
                            />
                            {item.name}
                            <span className="discount">
                              {item.name === "Pay Now"
                                ? "Save $" + item?.discount
                                : "Pay at Pickup"}
                            </span>
                            <span className="valueoption">${item.value}</span>
                          </Grid>
                        ))}
                      </Grid>

                      <table className="tbleforRenter">
                        <tbody>
                          <tr className="rowfont">
                            <td colSpan={2}>Before Taxes</td>
                            <td className="textr">${other?.beforeTaxAmount}</td>
                          </tr>

                          <tr className="rowfont">
                            <td colSpan={3}>{other?.days}</td>
                          </tr>
                          <tr className="rowfont">
                            <td colSpan={2}>Pay now discount</td>
                            <td className="textr">{-discount}</td>
                          </tr>
                          <tr className="rowfont">
                            <td colSpan={2}>
                              Extras{" "}
                              <span
                                className="expandicon"
                                onClick={handleExtra}
                              >
                                Expand <ArrowDownwardIcon />
                              </span>
                            </td>
                            <td className="textr">
                              $
                              {(
                                (other?.extrasAmount || extraamountTotal) ??
                                0
                              ).toFixed(2)}
                            </td>
                          </tr>
                          {extraBoll > 0 && (
                            <tr>
                              <td colSpan={3}>
                                <table className="subtable">
                                  <tr>
                                    <td>Damage Protection Plans</td>
                                    <td>
                                      {damage
                                        .filter((option) => option.isChecked)
                                        .map((option) => option?.title)}
                                    </td>
                                    <td className="textr"> $ {damageTotal}</td>
                                  </tr>
                                  <tr>
                                    <td>Additional Driver(s)</td>
                                    <td>
                                      {additionalDriver
                                        .filter((option) => option.isChecked)
                                        .map((option) => option?.title)}
                                    </td>
                                    <td className="textr">
                                      {" "}
                                      $ {additionalDriverTotal}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Glass & Tires</td>
                                    <td>
                                      {glassTires
                                        .filter((option) => option.isChecked)
                                        .map((option) => option?.title)}
                                    </td>
                                    <td className="textr">
                                      {" "}
                                      $ {glassTiresTotal}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Equipment</td>
                                    <td>
                                      {equipment
                                        .filter((option) => option.isChecked)
                                        .map((option) => option?.title)}
                                    </td>
                                    <td className="textr">
                                      {" "}
                                      $ {equipmentTotal}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Out of Province</td>
                                    <td>
                                      {outofProvince
                                        .filter((option) => option.isChecked)
                                        .map((option) => option?.title)}
                                    </td>
                                    <td className="textr">
                                      {" "}
                                      $ {outofProvinceTotal}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Extra Mileage</td>
                                    <td>
                                      {extraMileage
                                        .filter((option) => option.isChecked)
                                        .map((option) => option?.title)}
                                    </td>
                                    <td className="textr">
                                      {" "}
                                      $ {extraMileageTotal}
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          )}
                          <tr className="rowfont">
                            <td colSpan={2}>Fees</td>
                            <td className="textr">${other?.fee.toFixed(2)}</td>
                          </tr>
                          <tr className="rowfont">
                            <td colSpan={2}>
                              Airport Facility Charge Total for{" "}
                              {other?.airportFacilityChargeTotalForDays}
                            </td>
                            <td className="textr">
                              ${other?.airportFacilityChargeTotal}
                            </td>
                          </tr>
                          <tr className="rowfont">
                            <td colSpan={2}>Concession Fee</td>
                            <td className="textr">${other?.concessionFee}</td>
                          </tr>

                          <tr className="rowfont">
                            <td colSpan={2}>After Hour Fee</td>
                            <td className="textr">${other?.afterHourFee}</td>
                          </tr>
                          <tr className="rowfont">
                            <td colSpan={2}>After Hour Dropoff Fee</td>
                            <td className="textr">${other?.afterHourDropoffFee}</td>
                          </tr>
                          <tr className="rowfont">
                            <td colSpan={2}>Estimated Taxes</td>
                            <td className="textr">
                              ${estimatedTax.toFixed(2)}
                            </td>
                          </tr>

                          <tr className="rowfont fontsize">
                            <td colSpan={2}>
                              Total Amount (in {other?.currencyCode}): $
                              {amountTotal?.toFixed(2)})
                            </td>
                            <td className="textr">
                              ${amountTotal?.toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="totalamoutstikey">
                        Total Amount (in {other?.currencyCode}): $
                        {amountTotal?.toFixed(2)})
                      </div>
                    </Grid>
                    <Grid container spacing={2} style={{width:"100%"}}>
                      <Grid item sx={12} sm={6} >
                        <div className="boxloop" >
                          <Typography className="heading">
                            Damage Protection PlansReconsider?
                          </Typography>
                          {damage &&
                            damage.map((item, index) => (
                              <Grid
                                className="listbox"
                                position={"relative"}
                                key={"idx" + index}
                                item
                                xs={12}
                                alignItems={"left"}
                                textAlign={"left"}
                              >
                                <div className="name">
                                  <label htmlFor={"damage_" + item.id}>
                                    {item.title}
                                  </label>
                                </div>
                                <div className="value">${item.amount}</div>
                                <div className="radiobox">
                                  <input
                                    id={"damage_" + item.id}
                                    checked={item.isChecked}
                                    type="radio"
                                    onChange={(e) => handleRadio(e, index)}
                                    name="damage"
                                    value={item.amount}
                                  />
                                </div>
                              </Grid>
                            ))}
                        </div>
                        <div className="boxloop">
                          <Typography className="heading">
                            Additional Driver(s)
                          </Typography>
                          {additionalDriver &&
                            additionalDriver.map((item, index) => (
                              <Grid
                                className="listbox"
                                position={"relative"}
                                key={"idx" + index}
                                item
                                xs={12}
                                alignItems={"left"}
                                textAlign={"left"}
                              >
                                <div className="name">
                                  <label htmlFor={"additionalDriver_" + item.id}>
                                    {item.title}
                                  </label>
                                </div>
                                <div className="value">${item.amount}</div>
                                <div className="radiobox">
                                  <input
                                    id={"additionalDriver_" + item.id}
                                    checked={item.isChecked}
                                    type="radio"
                                    onChange={(e) => handleRadio(e, index)}
                                    name="additionalDriver"
                                    value={item.amount}
                                  />
                                </div>
                              </Grid>
                            ))}
                        </div>
                        <div className="boxloop">
                          <Typography className="heading">
                            Glass & Tires
                          </Typography>
                          {glassTires &&
                            glassTires.map((item, index) => (
                              <Grid
                                className="listbox"
                                position={"relative"}
                                key={"idx" + index}
                                item
                                xs={12}
                                alignItems={"left"}
                                textAlign={"left"}
                              >
                                <div className="name">
                                  <label htmlFor={"glassTires_" + item.id}>
                                    {item.title}
                                  </label>
                                </div>
                                <div className="value">${item.amount}</div>
                                <div className="radiobox">
                                  <input
                                    id={"glassTires_" + item.id}
                                    checked={item.isChecked}
                                    type="radio"
                                    onChange={(e) => handleRadio(e, index)}
                                    name="glassTires"
                                    value={item.amount}
                                  />
                                </div>
                              </Grid>
                            ))}
                        </div>
                        <div className="boxloop">
                          <Typography className="heading">Equipment</Typography>
                          {equipment &&
                            equipment.map((item, index) => (
                              <Grid
                                className="listbox"
                                position={"relative"}
                                key={"idx" + index}
                                item
                                xs={12}
                                alignItems={"left"}
                                textAlign={"left"}
                              >
                                <div className="name">
                                  <label htmlFor={"equipment_" + item.id}>
                                    {item.title}
                                  </label>
                                </div>
                                <div className="value">${item.amount}</div>
                                <div className="radiobox">
                                  <input
                                    id={"equipment_" + item.id}
                                    checked={item.isChecked}
                                    type="checkbox"
                                    onChange={(e) => handleRadio(e, index)}
                                    name="equipment"
                                    value={item.amount}
                                  />
                                </div>
                              </Grid>
                            ))}
                        </div>
                      </Grid>
                      <Grid item sx={12} sm={6}>
                        <div className="boxloop">
                          <Typography className="heading">
                            Out of Province
                          </Typography>
                          {outofProvince &&
                            outofProvince.map((item, index) => (
                              <Grid
                                className="listbox"
                                position={"relative"}
                                key={"idx" + index}
                                item
                                xs={12}
                                alignItems={"left"}
                                textAlign={"left"}
                              >
                                <div className="name">
                                  <label htmlFor={"outofProvince_" + item.id}>
                                    {item.title}
                                  </label>
                                </div>
                                <div className="value">${item.amount}</div>
                                <div className="radiobox">
                                  <input
                                    id={"outofProvince_" + item.id}
                                    checked={item.isChecked}
                                    type="radio"
                                    onChange={(e) => handleRadio(e, index)}
                                    name="outofProvince"
                                    value={item.amount}
                                  />
                                </div>
                              </Grid>
                            ))}
                        </div>

                        <div className="boxloop">
                          <Typography className="heading">
                            Extra Mileage
                          </Typography>
                          {extraMileage &&
                            extraMileage.map((item, index) => (
                              <Grid
                                className="listbox"
                                position={"relative"}
                                key={"idx" + index}
                                item
                                xs={12}
                                alignItems={"left"}
                                textAlign={"left"}
                              >
                                <div className="name">
                                  <label htmlFor={"extraMileage_" + item.id}>
                                    {item.title}
                                  </label>
                                </div>
                                <div className="value">${item.amount}</div>
                                <div className="radiobox">
                                  <input
                                    id={"extraMileage_" + item.id}
                                    checked={item.isChecked}
                                    type="radio"
                                    onChange={(e) => handleRadio(e, index)}
                                    name="extraMileage"
                                    value={item.amount}
                                  />
                                </div>
                              </Grid>
                            ))}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sx={12} lg={4}>
                  <Typography className="headbgblue" variant="h6">
                    Driver & Payment Information
                  </Typography>
                  <Grid container spacing={2} marginTop={"30px"}>
                    {basicDetail?.map((item) =>
                      item.name === "status" ? (
                        <Grid item xs={12} key={item.name}>
                          <EzControlledDropDowntWithFloatingLabel
                            name={item?.name}
                            control={control}
                            rules={item?.rule}
                            optionLabel={"name"}
                            optionValue={"id"}
                            options={statusDD}
                            isError={errors[item?.name]}
                            errorMsg={getFormErrorMessage(item?.name)}
                            label={item?.label}
                            labelClassName={"ml-2"}
                          />
                        </Grid>
                      ) : item.type === "date" ? (
                        <Grid item xs={12} key={item.name}>
                          <EzControlledCalendarWithFloatingLabel
                            id={item.name}
                            name={item.name}
                            {...register(item.name)}
                            showTime={false}
                            maxDate={new Date(2090, 0, 1)}
                            dateFormat="yy/mm/dd"
                            control={control}
                            isError={errors[item.name]}
                            errorMsg={getFormErrorMessage(item.name)}
                            label={item.label}
                            rules={
                              getFormBaseValidationRule().DEFAULT
                                .VALIDATION_RULE
                            }
                          />
                        </Grid>
                      ) : item.type === "checkbox" ? (
                        <Grid item xs={12} key={item.name}>
                          <Typography className="copycard">
                            Car Rental Company Rules & Restrictions (e.g.,
                            insurance, driver age, mileage and geographic
                            restrictions, shuttle info and additional charges)
                          </Typography>
                          <EzControlledCheckBoxWithLabel
                            name={item.name}
                            value={inclusiveRate}
                            id={item.name}
                            control={control}
                            rules={item?.rule}
                            isError={errors[item.name]}
                            errorMsg={getFormErrorMessage(item.name)}
                            label={item.label}
                            labelClassName={"ml-2"}
                            onChange={handleCheckbox}
                          />
                        </Grid>
                      ) : item.box === "half" ? (
                        <Grid item xs={6} key={item.name}>
                          <EzControlledInputWithFloatingLabel
                            name={item?.name}
                            control={control}
                            label={item?.label}
                            type={item?.type}
                            rules={item?.rule}
                            isError={errors[item?.name]}
                            errorMsg={getFormErrorMessage(item?.name)}
                          />
                        </Grid>
                      ) : (
                        <Grid item xs={12} key={item.name}>
                          <EzControlledInputWithFloatingLabel
                            name={item?.name}
                            control={control}
                            label={item?.label}
                            type={item?.type}
                            rules={item?.rule}
                            isError={errors[item?.name]}
                            errorMsg={getFormErrorMessage(item?.name)}
                          />
                        </Grid>
                      )
                    )}
                  </Grid>
                  <div className={"make-flex mt-3 mr-2"}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "end",
                      }}
                    >
                      <React.Fragment>
                        <div
                          style={{
                            margin: "15px 0px 15px 10px",
                            minWidth: "100px",
                          }}
                        >
                          <Button
                            type="submit"
                            label={isEdit ? "Update" : "Save"}
                            className="mt-2 p-button-raised"
                          />
                        </div>
                      </React.Fragment>
                    </div>
                  </div>
                </Grid>
              </Grid>

              {isEdit && (
                <Grid className="modsection" container spacing={2}>
                  {editMode?.map((item) => (
                    <Grid item xs={12} sm={3} key={item.name}>
                      <EzControlledInputWithFloatingLabel
                        name={item?.name}
                        control={control}
                        disabled={item?.disabled}
                        label={item?.label}
                        type={item?.type}
                        rules={item?.rule}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
            </form>
          )}
        </div>
      </div>
    </Container>
  );
};

export default CreateReservationsReservationsComponent;
